import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { RfvslmnpStore } from '../stores/rfvslmnp.store';

export const RfvslmnpSummaryGuard: CanMatchFn = () => {
  const rfvslmnpStore = inject(RfvslmnpStore);
  const router = inject(Router);

  if (!rfvslmnpStore.loadingStatus().isLoaded) {
    return router.createUrlTree(['rfvslmnp', 'form']);
  }

  return true;
};
